import { DeepLinkDataInterface, DeepLinkTypes } from "./types";

interface DeepLinkInterface {
    type: DeepLinkTypes;
    data?: DeepLinkDataInterface | any;
}

export class DeepLink implements DeepLinkInterface {
    type = DeepLinkTypes.unknow;
    data?: DeepLinkDataInterface = undefined;

    constructor(data: DeepLinkInterface) {
        Object.assign(this, data);
    }
}